import React, { useState, useCallback, useEffect } from "react";
import {
  HeaderContainer,
  HeaderLeftContainer,
  TypographyContainer,
  HeaderRightContainer,
} from "./Header.styled";
import { Typography, Button } from "@ann/web-components";
import CreateKnowledgeModal from "../CreateKnowledgeModal";

const Header = ({ 
  onKnowledgeBaseCreated,
  onCreateModalOpen,
  onOpenCreateModal,
  onCloseCreateModal,
  departmentsList = [],
}) => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  useEffect(() => {
    if (onCreateModalOpen !== undefined) {
      setIsCreateModalOpen(onCreateModalOpen);
    }
  }, [onCreateModalOpen]);

  const handleButtonClick = useCallback(() => {
    if (onOpenCreateModal) {
      onOpenCreateModal();
    } else {
      setIsCreateModalOpen(true);
    }
  }, [onOpenCreateModal]);

  const handleCloseModal = useCallback(() => {
    if (onCloseCreateModal) {
      onCloseCreateModal();
    } else {
      setIsCreateModalOpen(false);
    }
  }, [onCloseCreateModal]);

  const handleSuccess = useCallback(() => {
    if (onKnowledgeBaseCreated) {
      onKnowledgeBaseCreated();
    }
  }, [onKnowledgeBaseCreated]);

  return (
    <>
      <HeaderContainer>
        <HeaderLeftContainer>
          <TypographyContainer>
            <Typography category="title" size="small" weight="bold">
              Knowledge Hub
            </Typography>

            <Typography category="body" size="medium" weight="regular" color={"body"}>
              Select a knowledge base to manage its content
            </Typography>
          </TypographyContainer>
        </HeaderLeftContainer>

        <HeaderRightContainer>
          <Button
            iconRight="plus"
            label="New Knowledge Base"
            size="medium"
            onClick={handleButtonClick}
            type="gradient"
          />
        </HeaderRightContainer>
      </HeaderContainer>

      <CreateKnowledgeModal
        isOpen={isCreateModalOpen}
        onClose={handleCloseModal}
        onSuccess={handleSuccess}
        departmentsList={departmentsList}
      />
    </>
  );
};

export default Header;

